module.exports = __webpack_public_path__ + "img/list-pattern3.c78ad4c.svg";